// extracted by mini-css-extract-plugin
export default {"melodyVideo":"FL-z","isFullWidth":"GL-z","landingPageVideo":"HL-z","play":"IL-z","iframeVideo":"JL-z","playHidden":"KL-z","fullwidth":"LL-z"};